// from https://making.close.com/posts/react-native-webviews
import EventEmitter from 'events'
import { useEffect } from 'react'
import { PushNotificationActionType, ReactNativePayload } from './types'

const ReactNativeEvents = new EventEmitter()

/**
 * Registers event handler for a specific action with a callback which will be called after the event is triggered
 */
export const registerReactNativeHandler = (action: string, callback: (payload: ReactNativePayload) => void): (() => EventEmitter) => {
  ReactNativeEvents.on(action, callback)
  return () => ReactNativeEvents.off(action, callback)
}

/**
 * Custom hook to allow register react native event handler
 */
export const useReactNativeHandler = (action: PushNotificationActionType, callback: (payload: ReactNativePayload) => void): void => {
  useEffect(() => {
    const deregister = registerReactNativeHandler(action, callback)
    return () => {
      deregister()
    }
  }, [action, callback])
}

/**
 * Function which is added to window.onMessageFromReactNative so that it can be used by react native
 */
const onMessageFromReactNative = (message: string): void => {
  const { action, payload } = JSON.parse(message)
  ReactNativeEvents.emit(action, payload)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).onMessageFromReactNative = onMessageFromReactNative
